import { createRouter, createWebHistory } from 'vue-router'

import mainLayoutRouter from '@/router/mainLayoutRouter.js'

import Login from '@/views/Login.vue';
import MainLayout from '@/views/MainLayout.vue';
const routes = [{
  path: '/',
  component: MainLayout,
  children:mainLayoutRouter
},{
  path: '/login',
  name: 'Login',
  component: Login
},{
  path:'/his/:code',
  name:'his',
  component: () => import(/* webpackChunkName: "about" */ '../views/his.vue')
}]

const router = createRouter({
  base: process.env.VUE_APP_BASE_APP_URL,
  history: createWebHistory(process.env.VUE_APP_BASE_APP_URL),
  routes,
  mode:'history'
})

export default router
